import React from 'react'
import { Box } from '@mantine/core'
import { useSlopLibraryFeed } from './hooks/useSlopLibraryFeed'
import SlopFeedPageHeader from './SlopFeedPageHeader'
import SlopSecondaryNav from './SlopSecondaryNav'
import SlopLegacyLibrary from './SlopLegacyLibrary'
import SlopFeedOverlays from './SlopFeedOverlays'
import { slopFeedPageShellSx } from './slopFeedLayout'

/** Secondary route: paged long-form video library (upload + grid). */
export default function SlopLibraryPage () {
  const feed = useSlopLibraryFeed({ loadLibraryFeed: true })

  return (
    <Box sx={slopFeedPageShellSx}>
      <SlopSecondaryNav mode="library" isAdmin={feed.isAdmin} />
      <SlopFeedPageHeader
        variant="library"
        onUploadClick={() => feed.setUploadModalOpen(true)}
      />
      <SlopLegacyLibrary
        feedPosts={feed.feedPosts}
        feedLoading={feed.feedLoading}
        hasMore={feed.hasMore}
        sentinelRef={feed.sentinelRef}
        setSelectedPost={feed.setSelectedPost}
        requireAuth={feed.requireAuth}
        handleToggleLike={feed.handleToggleLike}
        handleShare={feed.handleShare}
      />
      <SlopFeedOverlays feed={feed} />
    </Box>
  )
}
